import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AdminContext } from "../context/AdminContext";

function Navigation() {
  const { isAdmin } = useContext(AdminContext);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar" role="navigation" aria-label="Navigation principale">
      <Link className="nav-signature" to="/" aria-label="Retour accueil — Alexandre Jack">
        Alexandre Jack
      </Link>

      {/* Desktop links */}
      <ul className="nav-links">
        <li>
          <a href="/prestation">Prestation</a>
        </li>
        <li>
          <a href="/bio">Bio</a>
        </li>
        <li>
          <a href="/gallery">Galerie</a>
        </li>
        {process.env.REACT_APP_ATELIERS_ENABLED === "true" && (
          <li>
            <a href="/ateliers">Ateliers</a>
          </li>
        )}
        {process.env.REACT_APP_SORTIES_THEMATIQUES_ENABLED === "true" && (
          <li>
            <a href="/sorties-thematiques">Sorties</a>
          </li>
        )}
        {process.env.REACT_APP_PARCOURS_ENABLED === "true" && (
          <li>
            <a href="/parcours-lyon">Parcours Lyon</a>
          </li>
        )}
        <li>
          <a href="/contact">Contact</a>
        </li>
        {isAdmin && (
          <li>
            <a href="/admin-connection">Admin</a>
          </li>
        )}
      </ul>

      {/* Mobile hamburger */}
      <button
        className="nav-hamburger"
        aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={isOpen}
        aria-controls="mobile-menu"
        onClick={toggleMenu}
      >
        <span className={`hamburger-bar ${isOpen ? "open" : ""}`} aria-hidden="true" />
        <span className={`hamburger-bar ${isOpen ? "open" : ""}`} aria-hidden="true" />
        <span className={`hamburger-bar ${isOpen ? "open" : ""}`} aria-hidden="true" />
      </button>

      {/* Mobile menu */}
      <ul
        id="mobile-menu"
        className={`nav-mobile ${isOpen ? "nav-mobile--open" : ""}`}
        aria-hidden={!isOpen}
      >
        <li>
          <a href="/prestation" onClick={closeMenu}>Prestation</a>
        </li>
        <li>
          <a href="/bio" onClick={closeMenu}>Bio</a>
        </li>
        <li>
          <a href="/gallery" onClick={closeMenu}>Galerie</a>
        </li>
        {process.env.REACT_APP_ATELIERS_ENABLED === "true" && (
          <li>
            <a href="/ateliers" onClick={closeMenu}>Ateliers</a>
          </li>
        )}
        {process.env.REACT_APP_SORTIES_THEMATIQUES_ENABLED === "true" && (
          <li>
            <a href="/sorties-thematiques" onClick={closeMenu}>Sorties</a>
          </li>
        )}
        {process.env.REACT_APP_PARCOURS_ENABLED === "true" && (
          <li>
            <a href="/parcours-lyon" onClick={closeMenu}>Parcours Lyon</a>
          </li>
        )}
        <li>
          <a href="/contact" onClick={closeMenu}>Contact</a>
        </li>
        {isAdmin && (
          <li>
            <a href="/admin-connection" onClick={closeMenu}>Admin</a>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navigation;
